import { MenuItemInterface } from "./menu-item.interface";

export class MenuItem implements MenuItemInterface {
    id: number = null;
    name: string;
    name_en: string = "";
    link?: string;
    children?: MenuItemInterface[] = [];
    parentId: number;
    parent?: MenuItemInterface = null;
    active: boolean = false;
    lon: number;
    lat: number;
    zoomLevel: number;
    lon_desktop: number;
    lat_desktop: number;
    zoomLevel_desktop: number;
    locations: Object[] = [];

    constructor(rawData?: MenuItemInterface) {
        Object.assign(this, rawData);
    }

    isChildOf(mi: MenuItemInterface): boolean {
        if (mi === null) {
            return false;
        }

        if (mi.id === this.id) {
            return true
        } else {
            return this.isChildOf(mi.parent)
        }
    }

    isAncestorOf(mi: MenuItemInterface): boolean {
        if (mi === null) {
            return false
        }

        if (mi.parent === this) {
            return true
        } else {
            return this.isAncestorOf(mi.parent)
        }
    }

    toPlainObject(): Object {
        let o = Object.assign({}, this)
        o.parent = null
        o.children = []
        o.locations = []
        return o
    }

    breadcrumbs(): String[] {
        let parent = this.parent
        let breadcrumbs = []

        if (parent !== null) {
            breadcrumbs.push(parent.name)

            while (parent?.parent !== null) {
                parent = parent.parent
                breadcrumbs.push(parent.name)
            }
        }

        return breadcrumbs.reverse()
    }
}